<div class="onboarding-page-wrapper onb-spy-page-wrapper">
    <div class="container landing-container">
        <div class="row mb-3" *ngIf="isPreRegistration">
            <div class="col-lg-9">
            </div>
            <div class="col-lg-2">
                <app-select class="new-label" [options]="draftBusinesses" [selectClass]="'ng-form-select primary-select select-change'"
                            label="New Business" selectPlaceholder="Select Business" [(selectedValue)]="businessSelect"
                            (selectedValueChange)="onChangeRestaurant($event)" [clearable]="true"></app-select>
            </div>
        </div>
        <form [formGroup]="formGroup">
            <div class="row">
                <div class="col-lg-8 col-xxl-auto">
                    <div class="scroll-block" style="height: calc(100vh - 150px); overflow-y: auto; position: relative;"
                         ngbScrollSpy #spy="ngbScrollSpy" container=".scroll-block" rootMargin="-60%" scrollBehavior="auto"
                         (scroll)="onScroll($event)">

                        <div class="scroll-card-dv" ngbScrollSpyFragment="items-1">
                            <div class="data-showcase-grid">
                                <div class="d-flex justify-content-between">
                                    <h4 class="grid-title">Main Information</h4>
                                    <button class="btn btn-text btn-upload-business text-uppercase d-none d-sm-flex"  *ngIf="isPreRegistration"
                                            (click)="openBusinessUploadModal(businessUploadComponent.businessUploadTemplate,'project-modal edit-food-menu-modal')">
                                        <img src="../assets/images/Upload.svg" alt="Add Icon" class="add-icon upload-hw btn-upload-icon" />
                                        Upload Business
                                    </button>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <app-input [inputType]="'text'" [fieldValue]="businessDetails.name" [fieldText]="'name'"
                                                   [fControl]="formGroup.controls['Name']" [inputClass]="'form-control'"
                                                   [inputPlaceholder]="'Enter Name'" [inputLabel]="'Name'" [labelClass]="'data-label'"
                                                   (keydown.enter)="$event.preventDefault()"></app-input>
                                    </div>
                                    <div class="col-sm-6">
                                        <app-select [options]="types" [selectClass]="'ng-form-select primary-select'"
                                                    selectPlaceholder="Select Type" label="Type" [(selectedValue)]="typeSelect"></app-select>
                                    </div>
                                    <div class="col-sm-6">
                                        <app-select [options]="cuisines" [selectClass]="'ng-form-select primary-select'"
                                                    selectPlaceholder="Select Cuisine" label="Cuisine" [(selectedValue)]="cuisineSelect"></app-select>
                                    </div>
                                    <div class="col-sm-6">
                                        <label class="data-label">Type Of Meal</label>
                                        <ng-select [items]="typeOfMeals" [multiple]="true" bindLabel="title" bindValue="id"
                                                   [selectableGroup]="false" [closeOnSelect]="false" [(ngModel)]="selectedTypeOfMeals"
                                                   [ngModelOptions]="{standalone: true}" placeholder="Select Type Of Meal"
                                                   class="ng-form-select primary-select multi-check-select" [clearable]="false">
                                            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                                <input id="item-{{index}}" type="checkbox" [ngModelOptions]="{standalone: true}"
                                                       [ngModel]="item$.selected" class="form-check-input" />
                                                {{item.title}}
                                            </ng-template>
                                        </ng-select>
                                    </div>
                                    <div class="col-sm-6">
                                        <app-select [options]="priceRanges" [selectClass]="'ng-form-select primary-select'"
                                                    selectPlaceholder="Select Price Range" label="Price Range"
                                                    [(selectedValue)]="priceSelect"></app-select>
                                    </div>
                                    <div class="col-sm-6">
                                        <app-select [options]="cities" [selectClass]="'ng-form-select primary-select'"
                                                    selectPlaceholder="Please enter at least 3 characters of city" label="City"
                                                    (searchEvent)="getCitiesBySearchText($event.term)" (focusEvent)="updateCityListOnBlur($event.term)"
                                                    [customDisplayOption]="'name, stateName, countryName'" isCustom="true"
                                                    [(selectedValue)]="citySelect"></app-select>
                                    </div>
                                    <div class="col-sm-6">
                                        <app-input [inputType]="'text'" [fieldValue]="businessDetails.address" [fieldText]="'address'"
                                                   [fControl]="formGroup.controls['Address']" [inputClass]="'form-control'"
                                                   [inputPlaceholder]="'Enter Address'" [inputLabel]="'Address'" [labelClass]="'data-label'"
                                                   [isRequired]="false" appNoSpecialCharacter
                                                   [maxLengthValidationMsg]="'Address must be at most 255 characters long.'"
                                                   (keydown.enter)="$event.preventDefault()"></app-input>
                                    </div>
                                    <div class="col-sm-6">
                                        <label class="data-label">Location</label>
                                        <div class="form-control"
                                             style="cursor: pointer;"
                                             (click)="openModalLocation(searchLocationComponent.searchLocationTemplate, 'set-location-modal-outer')">
                                            {{ initialLat ? 'Location Set' : (formGroup.controls['Location']?.value || 'Select Location') }}
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <label class="data-label">Description</label>
                                        <textarea class="form-control textarea-cnt" formControlName="Description"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="scroll-card-dv" ngbScrollSpyFragment="items-2">
                            <div class="data-showcase-grid">
                                <h4 class="grid-title">Details</h4>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <label class="data-label">Business Hours</label>
                                        <!-- <ng-select [(ngModel)]="businessHoursSelect" class="ng-form-select primary-select"
                                                                placeholder="-">
                                                                <ng-option *ngFor="let businessHours of businessHours"
                                                                    [value]="businessHours.id">{{businessHours.name}}</ng-option>
                                                            </ng-select> -->
                                        <!-- <textarea type="text" class="form-control" formControlName="BusinessHourDescription" placeholder="-"
                                        (click)="openBusinessHourModal(businessHourModalComponent.businessHourTemplate,'add-hours-modal')"></textarea> -->
                                        <div class="form-control textarea-replica"
                                             [ngClass]="{'placeholder-shown':!formGroup.get('BusinessHourDescription').value}"
                                             (click)="openBusinessHourModal(businessHourModalComponent.businessHourTemplate,'add-hours-modal')">
                                            <p *ngIf="!formGroup.get('BusinessHourDescription').value">-</p>
                                            <ng-container *ngIf="formGroup.get('BusinessHourDescription').value">
                                                <p *ngFor="let item of hourList" class="tooltip-line">
                                                    <ng-container *ngIf="item.From && item.To">
                                                        <span class="tooltip-day">{{ getDayName(item.Day) }}</span>
                                                        <span class="tooltip-time">{{ item.From }}</span>
                                                        <span class="tooltip-separator">-</span>
                                                        <span class="tooltip-time">{{ item.To }}</span>
                                                    </ng-container>

                                                </p>
                                            </ng-container>
                                        </div>
                                        <!-- <app-select  [options]="businessHours"
                                        [selectClass]="'ng-form-select primary-select'"
                                        selectPlaceholder="Select Business Hours" label="Business Hours" [(selectedValue)]="businessHoursSelect"></app-select> -->
                                    </div>
                                    <div class="col-sm-6">
                                        <app-input [inputType]="'text'" [fieldValue]="businessDetails.phoneNumber" [fieldText]="'phoneNumber'"
                                                   [fControl]="formGroup.controls['Phone']" [inputClass]="'form-control'"
                                                   [inputPlaceholder]="'Enter Phone Number'" [inputLabel]="'Phone Number'" [labelClass]="'data-label'"
                                                   [isRequired]="false" [minLengthValidationMsg]="
                      'Phone Number must be at least 7 digits long.'
                    " [maxLengthValidationMsg]="
                      'Phone Number must be at most 15 digits long.'
                  " [customErrorValidationMsg]="'Phone Number contains only digits.'" appNumbersOnly></app-input>
                                    </div>
                                    <div class="col-sm-6">
                                        <app-input [inputType]="'text'" [fieldValue]="businessDetails.website" [fieldText]="'Website'"
                                                   [fControl]="formGroup.controls['Website']" [inputClass]="'form-control'"
                                                   [inputPlaceholder]="'Enter Website'" [inputLabel]="'Website'" [labelClass]="'data-label'"
                                                   [isRequired]="false" [customErrorValidationMsg]="'Invalid Website URL'"
                                                   [maxLengthValidationMsg]="'Website Url must be at most 255 characters long.'"
                                                   (keydown.enter)="$event.preventDefault()"></app-input>
                                    </div>
                                    <div class="col-sm-6">
                                        <app-input [inputType]="'text'" [fieldValue]="businessDetails.instagram" [fieldText]="'instagram'"
                                                   [fControl]="formGroup.controls['Instagram']" [inputClass]="'form-control'"
                                                   [inputPlaceholder]="'Enter Instagram ID'" [inputLabel]="'Instagram'" [labelClass]="'data-label'"
                                                   [isRequired]="false" [customErrorValidationMsg]="'Invalid Instagram ID'"
                                                   [maxLengthValidationMsg]="'Instagram ID must be at most 30 characters long.'"
                                                   (keydown.enter)="$event.preventDefault()"></app-input>
                                    </div>
                                    <div class="col-sm-6">
                                        <app-input [inputType]="'text'" [fieldValue]="businessDetails.twitter" [fieldText]="'twitter'"
                                                   [fControl]="formGroup.controls['Twitter']" [inputClass]="'form-control'"
                                                   [inputPlaceholder]="'Enter Twitter ID'" [inputLabel]="'Twitter'" [labelClass]="'data-label'"
                                                   [isRequired]="false" [customErrorValidationMsg]="'Invalid Twitter ID'"
                                                   [minLengthValidationMsg]="'Twitter ID must be at least 5 characters long.'"
                                                   [maxLengthValidationMsg]="'Twitter ID must be at most 15 characters long.'"
                                                   (keydown.enter)="$event.preventDefault()"></app-input>
                                    </div>
                                    <div class="col-sm-6">
                                        <app-input [inputType]="'text'" [fieldValue]="businessDetails.businessMessage" [fieldText]="''"
                                                   [fControl]="formGroup.controls['BusinessMessage']" [inputClass]="'form-control'"
                                                   [inputPlaceholder]="'Enter Business Message'" [inputLabel]="'Business Message'"
                                                   [labelClass]="'data-label'" [isRequired]="false"
                                                   (keydown.enter)="$event.preventDefault()"></app-input>
                                    </div>
                                    <div class="col-12">
                                        <label class="data-label">Amenities</label>
                                        <div class="chip-control-block">
                                            <div class="form-btn-wrap d-flex gap-1">
                                                <app-select [options]="amenities" [selectClass]="'ng-form-select primary-select'"
                                                            selectPlaceholder="Select Amenities" [(selectedValue)]="aminitySelect"></app-select>
                                                <app-button (onBtnClick)="addAminity()" [btnText]="'Add'" [btnTitle]="'Add'"
                                                            [btnCss]="'btn btn-text text-uppercase'"></app-button>
                                            </div>
                                            <ul *ngFor="let amenity of selectedAmenities; let i=index" class="amenities-chip-wrap">
                                                <li>
                                                    {{amenity.title}}
                                                    <span class="close-span" (click)="selectedAmenities.splice(i,1)"> </span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="scroll-card-dv" ngbScrollSpyFragment="items-3">
                            <div class="data-showcase-grid gallery-grid" (click)="openModal(completeInfoComponent.completeInfoTemplate)">
                                <h4 class="grid-title with-count">
                                    Photos <span class="count">{{imageUrls.length}}</span>
                                </h4>

                                <div class="photo-tab-wrap">
                                    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
                                        <li [ngbNavItem]="i" *ngFor="let category of photoCategories; let i=index">
                                            <button ngbNavLink>
                                                {{category.name}} <span class="photo-count">{{getImagesByCategory(category.id).length}}</span>
                                            </button>
                                            <ng-template ngbNavContent>
                                                <div class="row">
                                                    <div class="col-sm-6 col-md-4">
                                                        <div class="file-upload-wrap">
                                                            <input #fileInput type="file" accept="image/*" (change)="onFileSelected($event, category.id)"
                                                                   [disabled]="!isFileInputEnabled" (click)="fileInput.value = ''" />
                                                            <!--<input #fileInput type="file" accept="image/*" (change)="openImageCongurationModal()"
                                                               [disabled]="!isFileInputEnabled" />-->
                                                            <div class="upload-inner">
                                                                <img src="./assets/images/ic-add.svg" alt="Add Icon" class="add-icon"
                                                                     (click)="fileInput.click()" />
                                                                <span>ADD PHOTO</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <ng-container *ngFor="let image of imageUrls; let i=index">
                                                        <app-photos-section *ngIf="image.imageType === category.id" [imageUrl]="image.imagePath"
                                                                            class="col-sm-6 col-md-4" [index]="i" (edit)="onEditImage(category.id, image.id);"
                                                                            (delete)="onDeleteImage(image.id);"></app-photos-section>
                                                    </ng-container>
                                                </div>
                                            </ng-template>
                                        </li>
                                    </ul>
                                    <div [ngbNavOutlet]="nav" class="mt-2"></div>
                                </div>
                            </div>
                        </div>

                        <div class="scroll-card-dv" ngbScrollSpyFragment="items-4">
                            <div class="data-showcase-grid food-dish-grid" (click)="openModal(completeInfoComponent.completeInfoTemplate)">
                                <h4 class="grid-title with-count s-bottom">
                                    Menu <span class="count">({{products.length}} dishes)</span>
                                </h4>
                                <div class="food-tab-outer">
                                    <ul ngbNav #dishNav="ngbNav" [(activeId)]="activeDishPanel" class="nav-tabs">
                                        <ng-container *ngFor="let category of menuCategories; let i=index">
                                            <li [ngbNavItem]="i">
                                                <button ngbNavLink>
                                                    {{category.title}}
                                                    <span class="photo-count">{{getProductsByCategory(category.id).length}}</span>
                                                </button>
                                                <ng-template ngbNavContent>
                                                    <div class="food-dish-wrap">
                                                        <ul class="dish-ul">
                                                            <ng-container *ngFor="let product of products; let i=index">
                                                                <li *ngIf="product.productCategoryId === category.id">
                                                                    <app-menu-section [menuTypes]="menuCategories" [productImageId]="product.productImageId"
                                                                                      [product]="product" style="display: flex; width: 100%"
                                                                                      (productDeleted)="productDeleted($event)" [currencySymbol]="businessDetails.sourceCurrency"
                                                                                      [businessPartnerId]="businessDetails.businessPartnerId"
                                                                                      (productUpdated)="menuUpdated($event)"></app-menu-section>
                                                                </li>
                                                            </ng-container>
                                                        </ul>
                                                        <p class="text-center no-record-found-text" *ngIf="checkNoRecord(category.id)">No Record Found!</p>
                                                    </div>
                                                </ng-template>
                                            </li>
                                        </ng-container>
                                    </ul>
                                    <button class="btn btn-text btn-add-item text-uppercase d-none d-sm-flex" (click)="
                  openMenuItemModal(
                    menuComponent.menuModalTemplate,
                    'project-modal edit-food-menu-modal'
                  )
                ">
                                        <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                  d="M9 5.40046L9 3.60046L5.40039 3.60046L5.40039 0.000243983L3.60039 0.000243905L3.60039 3.60046L-1.57371e-07 3.60046L-2.36051e-07 5.40046L3.60039 5.40046L3.60039 9.00024L5.40039 9.00024L5.40039 5.40046L9 5.40046Z"
                                                  fill="currentcolor" />
                                        </svg>
                                        Add Dish
                                    </button>
                                    <button class="btn btn-text btn-add-item btn-upload text-uppercase d-none d-sm-flex" (click)="
                  openProductUploadModal(
                    productUploadComponent.productUploadTemplate,
                    'project-modal edit-food-menu-modal'
                  )
                ">
                                        <img src="../assets/images/Upload.svg" alt="Add Icon" class="add-icon upload-hw" />
                                        Upload
                                    </button>
                                </div>
                                <div [ngbNavOutlet]="dishNav" class="mt-2"></div>
                                <button class="btn btn-text btn-add-item text-uppercase d-sm-none" (click)="
                openMenuItemModal(
                  menuComponent.menuModalTemplate,
                  'project-modal edit-food-menu-modal'
                )
              ">
                                    <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M9 5.40046L9 3.60046L5.40039 3.60046L5.40039 0.000243983L3.60039 0.000243905L3.60039 3.60046L-1.57371e-07 3.60046L-2.36051e-07 5.40046L3.60039 5.40046L3.60039 9.00024L5.40039 9.00024L5.40039 5.40046L9 5.40046Z"
                                              fill="currentcolor" />
                                    </svg>
                                    Add Dish
                                </button>
                            </div>
                        </div>

                        <div class="scroll-card-dv" ngbScrollSpyFragment="items-5">
                            <div class="data-showcase-grid">
                                <h4 class="grid-title">Mini Menu</h4>
                                <app-mini-menu-settings #miniMenuSettings [businessDetails]="businessDetails"></app-mini-menu-settings>
                            </div>
                        </div>

                        <div class="scroll-card-dv" ngbScrollSpyFragment="items-6" *ngIf="placesEnabled">
                            <div class="data-showcase-grid">
                                <h4 class="grid-title">Places</h4>
                                <p *ngIf="!(businessDetails.branchId > 0)">Save this business to select a Place.</p>
                                <button type="button" class="btn btn-outline-primary" *ngIf="businessDetails.branchId > 0 && !placesSettingsType"
                                        [disabled]="placesSettingsLoading" (click)="openPlacesSettings()">{{ placesSettingsLoading ? 'Loading…' : 'Manage Places' }}</button>
                                <p *ngIf="placesSettingsError" role="alert">{{ placesSettingsError }}</p>
                                <ng-container *ngComponentOutlet="placesSettingsType; inputs: placesSettingsInputs"></ng-container>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="col-lg-4 col-xxl">
                    <div class="onboarding-sidebar" [class.show-onboarding-sidebar]="isOnboardingSidebarActive">
                        <ul>
                            <li>
                                <button type="button"
                                        [class]="activeSection === 'items-1' ? 'btn active' : 'btn'"
                                        title="Main Information"
                                        (click)="scrollToSection('items-1')">
                                    <span class="icon-block"></span>
                                    Main Information
                                </button>
                            </li>
                            <li>
                                <button type="button"
                                        [class]="activeSection === 'items-2' ? 'btn active' : 'btn'"
                                        title="Details"
                                        (click)="scrollToSection('items-2')">
                                    <span class="icon-block"></span>
                                    Details
                                </button>
                            </li>
                            <li>
                                <button type="button"
                                        [class]="activeSection === 'items-3' ? 'btn active' : 'btn'"
                                        title="Photos"
                                        (click)="scrollToSection('items-3')">
                                    <span class="icon-block"></span>
                                    Photos
                                </button>
                            </li>
                            <li>
                                <button type="button"
                                        [class]="activeSection === 'items-4' ? 'btn active' : 'btn'"
                                        title="Menu"
                                        (click)="scrollToSection('items-4')">
                                    <span class="icon-block"></span>
                                    Menu
                                </button>
                            </li>
                            <li>
                                <button type="button"
                                        [class]="activeSection === 'items-5' ? 'btn active' : 'btn'"
                                        title="Mini Menu"
                                        (click)="scrollToSection('items-5')">
                                    <span class="icon-block"></span>
                                    Mini Menu
                                </button>
                            </li>
                            <li *ngIf="marketplaceEntry.isConfigured && placesEnabled">
                                <button type="button" [class]="activeSection === 'items-6' ? 'btn active' : 'btn'" title="Places" (click)="openPlacesSettings()">
                                    <span class="icon-block"></span>Places
                                </button>
                            </li>
                            <li *ngIf="marketplaceEntry.isConfigured">
                                <button type="button" class="btn"
                                        title="Open subscriptions in EVOLUTION Marketplace in a new window"
                                        aria-label="Subscriptions (opens in a new window)"
                                        [disabled]="openingMarketplace || !(businessDetails.businessPartnerId > 0)"
                                        [attr.aria-busy]="openingMarketplace"
                                        (click)="openMarketplace()">
                                    <span class="icon-block"></span>
                                    {{ openingMarketplace ? 'Opening…' : 'Subscriptions' }}
                                </button>
                                <p *ngIf="showSubscriptionSaveNote" class="small mt-2 mb-0">
                                    Save this business to manage subscriptions.
                                </p>
                                <p *ngIf="marketplaceEntryError" role="alert" class="text-danger small mt-2 mb-0">{{ marketplaceEntryError }}</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="bottom-action bottom-action-onb-cst">
        <div class="bottom-action-inner">
            <div class="btn-grps">
                <app-button [btnCss]="'btn btn-danger'" [btnTitle]="'Cancel Edits'" (onBtnClick)="cancelChanges()"
                            [btnText]="'Cancel Edits'"></app-button>
                <app-button [btnCss]="'btn btn-primary'" [btnTitle]="'Save Details'" [btnText]="'Save Details'"
                            [isDisable]="savingBusinessDetails" (onBtnClick)="saveBusinessDetails()"></app-button>
                <!-- Publish moved into the Save Details flow (publish-or-continue modal) so the action bar
                     keeps just Cancel + Save Details; the third button was breaking the button text layout. -->

                <app-button [btnCss]="'btn btn-fab d-lg-none'" [btnTitle]="''" [btnText]="''"
                            (onBtnClick)="viewOnboardingSideBar()" class="d-lg-none">
                    <svg id="Layer_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512"
                         xmlns="http://www.w3.org/2000/svg" fill="#FFFFFF">
                        <path d="m464.883 64.267h-289.233c-25.98 0-47.117 21.137-47.117 47.149 0 25.98 21.137 47.117 47.117 47.117h289.232c25.98 0 47.117-21.137 47.117-47.117.001-26.013-21.136-47.149-47.116-47.149z" />
                        <path d="m47.134 64.267c-25.989 0-47.134 21.144-47.134 47.133s21.145 47.133 47.134 47.133 47.133-21.144 47.133-47.133-21.144-47.133-47.133-47.133z" />
                        <path d="m47.134 208.867c-25.989 0-47.134 21.144-47.134 47.133s21.145 47.133 47.134 47.133 47.133-21.144 47.133-47.133-21.144-47.133-47.133-47.133z" />
                        <path d="m47.134 353.467c-25.989 0-47.134 21.144-47.134 47.133s21.145 47.133 47.134 47.133 47.133-21.144 47.133-47.133-21.144-47.133-47.133-47.133z" />
                        <path d="m464.883 208.867h-289.233c-25.98 0-47.117 21.137-47.117 47.149 0 25.98 21.137 47.117 47.117 47.117h289.232c25.98 0 47.117-21.137 47.117-47.117.001-26.013-21.136-47.149-47.116-47.149z" />
                        <path d="m464.883 353.467h-289.233c-25.98 0-47.117 21.137-47.117 47.149 0 25.98 21.137 47.117 47.117 47.117h289.232c25.98 0 47.117-21.137 47.117-47.117.001-26.012-21.136-47.149-47.116-47.149z" />
                    </svg>
                </app-button>
            </div>
        </div>
    </div>
</div>
<app-menu #menu (menuAdded)="menuAdded($event)" [types]="menuCategories" [menuCount]="products.length" [businessPartnerId]="businessDetails.businessPartnerId"></app-menu>
<app-complete-info-modal #completeInfoModal></app-complete-info-modal>
<app-confirm-info-modal #confirmationModal (okBtnClicked)="registerBusiness()"></app-confirm-info-modal>
<app-business-hour-modal [DayOfWeek]="dayOfWeek" [hourList]="hourList" (businessHourAdded)="businessHourAdded($event)"
                         #businessHourModal></app-business-hour-modal>
<app-product-upload #productUploadModal [businessDetails]="businessDetails" (onClose)="closeProductModal($event)"></app-product-upload>
<app-business-upload #businessUploadModal (onClose)="closeBusinessModal($event)"></app-business-upload>


<app-search-location (openProfileModal)="openModalLocation(profileTemplate, 'add-profile-modal')"
                     (FillAddressDetails)="FillAddressDetails($event)"
                     [emitCloseEvent]="false"
                     [addressOnboarding]="formGroup.controls['Address'].value"
                     [cityOnboarding]="citySelect ? citySelect.name + ', ' + citySelect.stateName + ', ' + citySelect.countryName : (businessDetails.cityName || '')"
                     [businessDetaillat]="formGroup.controls['Latitude'].value"
                     [businessDetaillng]="formGroup.controls['Longitude'].value"
                     #searchLocationModal>
</app-search-location>
<app-resto-publish-info-popup #restoInfoModal></app-resto-publish-info-popup>

<ng-template #placesRemovalConfirmModal let-modal>
    <div class="modal-head">
        <button class="btn btn-close" aria-label="Cancel" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
        <h2 class="title-text" ngbAutofocus>Remove selected Place?</h2>
        <p class="info-text">Saving this location will remove your selected Place from your profile. You will need to select another Place and go through location approval again, or unsubscribe.</p>
        <div class="btn-grps">
            <button class="btn btn-primary" (click)="modal.close(true)">Save location and remove Place</button>
            <button class="btn btn-outline-primary" (click)="modal.dismiss()">Keep editing</button>
        </div>
    </div>
</ng-template>

<!-- Publish-or-continue prompt shown after Save Details on a pre-approved (publishable) business.
     Mirrors the confirm-info-modal design (warning-section-modal). -->
<ng-template #publishConfirmModal let-modal>
    <div class="modal-head">
        <button class="btn btn-close" (click)="modal.close('Close click')"></button>
    </div>
    <div class="modal-body">
        <div class="img-wrap">
            <img src="./assets/images/ic-confirmation.svg" alt="Icon">
        </div>
        <h2 class="title-text" ngbAutofocus>Publish business?</h2>
        <h5 class="info-text">
            Your changes have been saved. Would you like to publish this business now, or keep editing?
        </h5>
        <div class="btn-grps">
            <button class="btn btn-primary" title="Publish"
                    (click)="modal.close('Close click'); publishRestaurant();">Publish</button>
            <button class="btn btn-outline-primary" title="Continue Editing"
                    (click)="modal.close('Close click')">Continue Editing</button>
        </div>
    </div>
</ng-template>

<!--<app-image-configuration #imageConfigurationModal (result)="getImage($event)"></app-image-configuration>-->
